// extracted by mini-css-extract-plugin
export default {"td":"PersonalizacaoPontoIndex_td__s9jO1","inscricao":"PersonalizacaoPontoIndex_inscricao__2BmZY"};